import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchMe = useCallback(async () => {
        const token = localStorage.getItem("dw_token");
        if (!token) { setLoading(false); return; }
        try {
            const res = await api.get("/auth/me");
            setUser(res.data);
        } catch (e) {
            localStorage.removeItem("dw_token");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchMe(); }, [fetchMe]);

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("dw_token", res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };
    const signup = async (data) => {
        const res = await api.post("/auth/signup", data);
        localStorage.setItem("dw_token", res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };
    const logout = () => {
        localStorage.removeItem("dw_token");
        setUser(null);
    };
    const setToken = (token) => {
        if (token) {
            localStorage.setItem("dw_token", token);
            fetchMe();
        } else {
            logout();
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, signup, logout, refresh: fetchMe, setToken }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
